import FetchHelpers from '../../utils/FetchHelpers';
import formUrl from '../../utils/routes';

export default {
  create(messageId, params) {
    const url = formUrl(`/api/v1/admin/messages/${messageId}/messages_users`);

    return FetchHelpers.post(url, params);
  },
};
